import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { AnalyticsService } from '../core/services/analytics.service';
import { InquiryAnalytics } from '../core/models/inquiry-analytics';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss'],
  providers: [AnalyticsService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DebugComponent {
  protected currentTenantIdentifier = '';
  protected currentInquiryId = '';

  protected readonly result = signal<InquiryAnalytics | null>(null);
  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly snackBar: MatSnackBar,
  ) {}

  getInquiryData() {
    if (this.currentTenantIdentifier && this.currentInquiryId) {
      this.analyticsService
        .getAnalyticsForTenantAndInquiry(
          this.currentTenantIdentifier,
          this.currentInquiryId,
        )
        .subscribe({
          next: (x) => {
            this.result.set(x);
          },
          error: () => {
            this.result.set(null);
            this.snackBar.open('Error while loading inquiry data.', 'Ok', {
              duration: 2_500,
            });
          },
        });
    }
  }
}
